/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { notificationStore } from 'stores';
import { tracingService, trackingService } from 'services';

import saveFile from './save-file';

/**
 * Converts a given BPMN diagram into an SVG image and downloads
 * it to the user's computer.
 *
 * @param {Object} modeler An instance of the bpmn-js Modeler with access to the `saveSVG` method.
 * @param {Object} diagram
 * @param {String} [diagram.name] The diagram's name.
 * @param {String} [diagram.type] The diagram's type, like `BPMN`.
 */
export default async function exportDiagramSVG(modeler, diagram) {
  try {
    const fileName = `${diagram.name}.svg`;
    const { svg } = await modeler.saveSVG();

    saveFile(svg, fileName);

    notificationStore.showSuccess(`"${fileName}" is being downloaded to your computer.`);
    trackingService.trackFileExport({
      // @ts-expect-error TS2339
      fileId: diagram.id,
      // @ts-expect-error TS2322
      fileTypeKey: diagram.type,
      exportType: 'svg',
      from: 'diagram',
      fileCount: 1,
      fileSize: svg.length
    });
  } catch (ex) {
    notificationStore.showError('Yikes! Something went wrong while preparing your download. Please try again later.');
    tracingService.traceError(ex, 'Failed to export diagram as SVG');
  }
}
